import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { imageUrl } from "@/lib/api";
import DateBadge from "./DateBadge";

const STATUS_LABEL = {
  sold_out: "SOLD OUT",
  cancelled: "CANCELLED",
  coming_soon: "COMING SOON",
};

export default function EventCard({ event, className = "" }) {
  const badge = STATUS_LABEL[event.status];
  const soldOut = event.status === "sold_out";
  const cancelled = event.status === "cancelled";
  const coming = event.status === "coming_soon";

  return (
    <Link
      to={`/events/${event.slug}`}
      data-testid={`event-card-${event.slug}`}
      className={`group relative flex flex-col overflow-hidden rounded-xl bg-[#141417] border border-[#27272A] transition-all duration-300 hover:border-[#D4AF37]/60 hover:shadow-[0_0_30px_rgba(212,175,55,0.12)] ${className}`}
    >
      <div className="relative aspect-[4/5] overflow-hidden">
        <img
          src={imageUrl(event.flyer_image)}
          alt={event.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 card-fade" />
        <div className="absolute top-3 left-3">
          <DateBadge date={event.date} />
        </div>
        {badge && (
          <div className="absolute top-3 right-3">
            <span className={`font-oswald text-[10px] font-bold tracking-widest px-2 py-1 rounded ${cancelled ? "bg-red-600 text-white" : coming ? "bg-white/15 text-white backdrop-blur" : "bg-[#D4AF37] text-black"}`}>
              {badge}
            </span>
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="font-display text-2xl uppercase leading-none text-white line-clamp-2">{event.name}</h3>
        </div>
      </div>
      <div className="flex flex-col gap-3 p-4">
        <div className="flex items-center gap-1.5 text-[13px] text-zinc-400">
          <MapPin size={14} className="text-gold shrink-0" />
          <span className="truncate">
            {event.venue ? `${event.venue.name} — ${event.venue.city}` : "Location TBA"}
          </span>
        </div>
        <div className="mt-1">
          {coming ? (
            <div className="w-full text-center rounded-md border border-white/15 py-2.5 font-oswald text-sm font-semibold tracking-wide text-white">
              COMING SOON
            </div>
          ) : soldOut || cancelled ? (
            <div className="w-full text-center rounded-md border border-white/15 py-2.5 font-oswald text-sm font-semibold tracking-wide text-zinc-400">
              {cancelled ? "CANCELLED" : "SOLD OUT"}
            </div>
          ) : (
            <div className="w-full text-center rounded-md bg-white py-2.5 font-oswald text-sm font-bold tracking-wide text-black transition-colors group-hover:bg-[#D4AF37]">
              GET TICKETS
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
